import { DeviceService } from '@/http-services/device.service';
import { DeviceLocation } from 'common';
import { ref, shallowRef, watch } from 'vue';

export function useDeviceLocation(getDeviceId: () => number | null | undefined) {
  const deviceService = new DeviceService();
  const loadingLocation = ref(false);
  const location = shallowRef<DeviceLocation>();

  watch(getDeviceId, (id, oldId) => {
    if (id !== oldId) {
      location.value = undefined;
    }

    if (id) {
      loadingLocation.value = true;
      deviceService.findDevice(id).then((l) => {
        loadingLocation.value = false;
        location.value = l;
      });
    } else {
      location.value = undefined;
      loadingLocation.value = false;
    }
  });

  return {
    loadingLocation,
    location,
  };
}
